
let isSyncing = false;


document.addEventListener("DOMContentLoaded", function () {
  // Save to localStorage
  function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
  }

  // Initialization logic for a single select
  function initializeSelect(select) {
    if (select.dataset.initialized) return; // Prevent re-initialization
    select.dataset.initialized = "true";

    const type = select.childElementCount > 5 ? "phone" : "airpod";
    const group = select.closest("[data-sync-group]")?.dataset.syncGroup;
    const storageKey = `selectedModelOption_${type}`;
    let stored = localStorage.getItem(storageKey);

    // If stored value exists and matches an option, apply it
    if (stored !== null) {
      const optionExists = Array.from(select.options).some(
        (opt) => opt.value === stored
      );
      if (optionExists) {
        select.value = stored;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Sync changes across grouped selects and update localStorage
    select.addEventListener("change", function () {
      if (isSyncing) return;
      isSyncing = true;
      const value = select.value;
      saveToLocalStorage(storageKey, value);

      //Global event which components can listen to
      document.dispatchEvent(new CustomEvent("model-changed"));


      //Really this could be moved to the consumer, making them listen on model-changed
      if (group) {
        document
          .querySelectorAll(
            `[data-sync-group="${group}"] select[name="options[Model]"]`
          )
          .forEach((s) => {
            if (s !== select) {
              s.value = value;
              s.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
      }
      isSyncing = false;
    });

    select.dispatchEvent(new Event("change"))

  }

  // Initialize current selects
  const modelInAllLanguages = ["Model", "Modelo", "Modell", "Modèle"]
  const selector = modelInAllLanguages.map(model => `select[name="options[${model}]"]`).join(",")
  const selects = document.querySelectorAll(selector);
  selects.forEach(initializeSelect);

  // Setup MutationObserver to watch for new selects being added
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return; // Only elements

        // Direct match
        if (node.matches?.('select[name="options[Model]"]')) {
          initializeSelect(node);
        }

        // Any nested selects
        node.querySelectorAll?.('select[name="options[Model]"]').forEach(initializeSelect);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

